module.exports = __webpack_public_path__ + "img/sw-ps-xl.de79e3ab.webp";